<template>
    <v-container
        raw
        fluid
        xs12
        style="margin: 0; padding: 0"
        transition="scroll-x-transition"
        v-if="isRoot"
    >
        <v-app-bar
            app
            clipped-left
            flat
            class="pa-0 ma-0"
            :color="!$vuetify.display.mobile ? 'transparent' : 'primary'"
            v-if="currentUser && currentUser.profile && $route.name !== 'maintenance'"
            :dense="$vuetify.display.mobile"
        >
            <v-app-bar-title
                style="max-width: 256px"
                color="transparent"
                class="d-flex justify-center align-center"
            >
                <v-img :src="logoBobbeeMini" height="40px" />
            </v-app-bar-title>
            <v-row no-gutters color="white" class="fill-height bg-white rounded-bs-xl px-8">
                <v-col cols="7" class="d-flex align-center"> </v-col>
                <v-col cols="5" class="d-flex align-center justify-end">
                    <v-btn-icon
                        v-if="
                            currentUser &&
                            currentUser.profile &&
                            currentUser.profile.configuration.internalManagement.access
                        "
                        icon="$oss-outlined-home"
                        color="primary"
                        @click="accoutantHome()"
                        :style="topButtonStyle"
                    >
                    </v-btn-icon>
                    <profile-menu />
                </v-col>
            </v-row>
        </v-app-bar>

        <v-navigation-drawer
            color="primary"
            app
            clipped
            flat
            floating
            class="navigation rounded-te-xl d-flex"
        >
            <v-list-item
                @click="$router.push({ name: 'controlCenterDashboard' })"
                v-if="!isAccountingEmployee"
            >
                <template #prepend>
                    <v-icon>$fa-home</v-icon>
                </template>
                <v-list-item-title>Dashboard</v-list-item-title>
            </v-list-item>
            <v-list-item
                @click="$router.push({ name: 'controlCenterAPI' })"
                v-if="!isAccountingEmployee"
            >
                <template #prepend>
                    <v-icon>$fa-user-cog</v-icon>
                </template>
                <v-list-item-title>API</v-list-item-title>
            </v-list-item>
            <template v-slot:append>
                <v-row no-gutters class="mb-4">
                    <v-col cols="3" class="d-flex justify-end align-end text--primary px-1">
                        by
                    </v-col>
                    <v-col cols="9" class="d-flex">
                        <v-img src="../../assets/img/bobbee_hrz.png" height="30px" />
                    </v-col>
                </v-row>
            </template>
        </v-navigation-drawer>
        <v-main
            raw
            fluid
            xs12
            class="background_image d-flex align-start fill-height"
            style="width: 100%; margin: 0"
        >
            <transition name="slide-fade" class="fill-height">
                <router-view transition="scroll-x-transition" class="fill-height" />
            </transition>
        </v-main>
    </v-container>
</template>

<script lang="ts">
import { User } from "../../store/store";

import ProfileMenu from "../auth/ProfileMenu.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";

const logoBobbeeMini = require("../../assets/img/bobbee_mini.png");

@Component({
    components: {
        ProfileMenu,
    },
})
export class ControlCenterIndex extends Vue {
    get logoBobbeeMini() {
        return logoBobbeeMini;
    }

    get topButtonStyle() {
        let style = "pointer-events:auto; margin-right: 3px;";
        return style;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingEmployee() {
        return this.currentUser.isAccountingEmployee;
    }

    get isRoot() {
        return this.currentUser?.isRoot;
    }

    beforeMount() {
        if (!this.isRoot) {
            this.$router.push({ name: "accountant-home" });
        }
    }

    accoutantHome() {
        this.$router.push({ name: "accountant-home" });
    }
}

export default toNative(ControlCenterIndex);
</script>
